function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { HTML_ATTRIBUTE_CAPTURE_PREFIX, HTML_ATTRIBUTE_VISUAL_PARENT, HTML_ATTRIBUTE_BLOCKER_CONNECTED } from ".";
import { putHtmlCodeToDom } from "..";
var HTML_ATTRIBUTE_TRANSFORM_WRAPPER = "consent-transform-wrapper";
var HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE = "1";
/**
 * Transform e. g. `consent-original-href` to `href` of a given node.
 */

function transformToOriginalContentBlockerAttribute(node) {
  return new Promise(function (resolve) {
    var _node$parentElement;

    // Scripts need to be handled differently cause we want to use `postscribe` and should not be attached
    // to the DOM -> not be executed
    var isScript = node.tagName.toLowerCase() === "script";
    var workWithNode = isScript ? node.cloneNode(true) : node; // Do the transformation from "blocked" state to "unblocked"

    var _iterator = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attribute = _step.value;

        if (attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_PREFIX)) {
          var originalAttribute = attribute.substr(HTML_ATTRIBUTE_CAPTURE_PREFIX.length + 1);
          workWithNode.setAttribute(originalAttribute, workWithNode.getAttribute(attribute));
          workWithNode.removeAttribute(attribute);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    workWithNode.style.removeProperty("display"); // Also make the parent visual visible again

    if (node.hasAttribute(HTML_ATTRIBUTE_VISUAL_PARENT) || (_node$parentElement = node.parentElement) !== null && _node$parentElement !== void 0 && _node$parentElement.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
      node.parentElement.style.removeProperty("display");
    }

    if (!isScript) {
      resolve();
    } else {
      // We do need to create a `span` for postscribe cause the <script> tag can not be used in this case
      var outerHTML = workWithNode.outerHTML; // Check if there is already a wrapper known

      var previousElementSibling = node.previousElementSibling;
      var referenceNode;

      if (previousElementSibling !== null && previousElementSibling !== void 0 && previousElementSibling.hasAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER)) {
        referenceNode = previousElementSibling;
      } else {
        referenceNode = document.createElement("div"); // we need to have a `block`ing element

        referenceNode.setAttribute(HTML_ATTRIBUTE_TRANSFORM_WRAPPER, HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE);
        node.parentElement.replaceChild(referenceNode, node);
      }

      putHtmlCodeToDom(outerHTML, {}, referenceNode).then(resolve);
    }
  });
}

export { transformToOriginalContentBlockerAttribute, HTML_ATTRIBUTE_TRANSFORM_WRAPPER, HTML_ATTRIBUTE_TRANSFORM_WRAPPER_VALUE };